export const resolveNavigatePath = (navigate?: string | null): string | null => {
  if (!navigate) return null
  const trimmed = navigate.replace(/^\/+/, '')
  const parts = trimmed.split('/').filter(Boolean)

  if (parts[0] === 'exports') {
    return 'react/items/exports'
  }

  if (parts[0] === 'imports') {
    return 'react/exchange-center'
  }

  if (parts[0] === 'react') {
    if ((parts[1] === 'edit-task' || parts[1] === 'add-task') && parts[2]) {
      return `react/pipeline/${parts[1]}/${parts[2]}`
    }
    return trimmed
  }

  if (parts[0] === 'edit-task' || parts[0] === 'add-task') {
    return `react/pipeline/${parts[0]}${parts[1] ? `/${parts[1]}` : ''}`
  }

  return `react/${trimmed}`
}

export const openNotificationNavigate = (navigate?: string | null) => {
  const path = resolveNavigatePath(navigate)
  if (!path) return
  window.open(`/#/${path}`, '_blank')
}
